import React from 'react';
import { Link } from 'react-router-dom';
import { Users, MessageCircle, Newspaper, BookHeart } from 'lucide-react';
import { AnimatedIcon, IconMotion } from './AnimatedIcon';

/**
 * Fonte única dos ícones da Comunidade (design minimal v1).
 * Usada pelo /community-hub e pelos atalhos no topo de Amigos, Chat, Feed e Clube do Livro,
 * para que o mesmo destino tenha sempre o mesmo ícone.
 */
export type CommunitySection = 'friends' | 'chat' | 'feed' | 'clubs';

export const COMMUNITY_ICONS: Record<CommunitySection, { Icon: React.FC<any>; path: string; motion: IconMotion; title: string }> = {
  friends: { Icon: Users, path: '/friends', motion: 'bounce', title: 'Amigos' },
  chat: { Icon: MessageCircle, path: '/chat', motion: 'wobble', title: 'Chat' },
  feed: { Icon: Newspaper, path: '/community-feed', motion: 'pop', title: 'Comunidade' },
  clubs: { Icon: BookHeart, path: '/book-club', motion: 'flip', title: 'Clube do Livro' },
};

const ORDER: CommunitySection[] = ['friends', 'chat', 'feed', 'clubs'];

/** Atalhos para as outras 3 páginas da Comunidade (a atual fica de fora). */
export const CommunityLinks: React.FC<{ current: CommunitySection }> = ({ current }) => (
  <span data-tour="community-links" className="flex items-center gap-2">
    {ORDER.filter(k => k !== current).map(k => {
      const { Icon, path, motion, title } = COMMUNITY_ICONS[k];
      return (
        <Link key={k} to={path} className="w-10 h-10 rounded-full bg-surface border border-black/[0.06] dark:border-white/[0.06] text-ink hover:bg-tint-stone flex items-center justify-center transition-colors" title={title} aria-label={title}>
          <AnimatedIcon motion={motion}><Icon size={17} strokeWidth={1.75} /></AnimatedIcon>
        </Link>
      );
    })}
  </span>
);
